export default __webpack_public_path__ + "static/media/live_as_disciple.e25e5d78.svg";